<template>
  <div class="member-invite-enter-code">
    <cookies-disabled-error v-if="cookiesDisabledError" class="error-holder" />
    <invite-member-already-exists-error
      v-else-if="memberAlreadyExists"
      :phone-number="phoneNumber"
      :inviter="primaryMemberDetails.firstNamePiiValue" />
    <div v-else>
      <img class="image-container" :src="require('@/assets/hero-login.svg')">
      <div class="content">
        <enter-code class="enter-code"
                    :first-name="firstName"
                    :phone-number="phoneNumber"
                    :confirm-code-action="createMemberAndProceed"
                    :regenerate-code-action="forceGenerateCode"
                    :server-error="errors.createMember"
                    :button-title="'אישור'"
                    :loading="loading"
                    :reset-error="() => resetError('createMember')"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from 'vuex';
import InviteMemberAlreadyExistsError
  from '@/pages/responsive-pages/invite-authenticated/member-invite/pages/InviteMemberAlreadyExistsError';
import CookiesDisabledError from '@/pages/general-errors/CookiesDisabledError.vue';
import Segment from '@/Segment';
import EnterCode from '@/base-components/EnterCode.vue';

export default {
  name: 'MemberInviteEnterCode',
  components: {
    InviteMemberAlreadyExistsError,
    EnterCode,
    CookiesDisabledError,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  async created() {
    Segment.trackUserGot('MemberInviteEnterCodeEntered');
  },
  computed: {
    ...mapState('memberInvite', ['firstName', 'lastName', 'phoneNumber', 'errors']),
    ...mapGetters('memberInvite', ['inviteMemberFlowSteps', 'errorTypes']),
    ...mapState('inviteSession', ['primaryMemberDetails']),
    memberAlreadyExists() {
      return this.errors.createMember === this.errorTypes.memberAlreadyExists;
    },
    cookiesDisabledError() {
      return this.errors.createMember === this.errorTypes.cookiesDisabled;
    },
  },
  methods: {
    ...mapMutations('memberInvite', ['resetError', 'setPhoneNumber']),
    ...mapActions('memberInvite', ['createMember', 'forceGenerateCode', 'authenticate']),
    async createMemberAndProceed(code) {
      try {
        this.loading = true;
        this.setPhoneNumber(this.phoneNumber);
        await this.authenticate(code);
        await this.createMember();
        this.next();
      } catch (e) {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  @import 'src/scss/mixins';

  .error-holder {
    margin: 30px;
  }

  .member-invite-enter-code {
    width: 100%;

    .image-container {
      width: 100%;
    }

    .content {
      margin: 30px;
    }

    .enter-code {
      @include responsive-padding;
      width: 100%;
    }
  }

</style>
